import { TextField as Field } from '../../../../../components/Toolkit/Inputs/TextField';
import styled from 'styled-components';

/**
 * Ovewriting the styles so that readOnly field appears disabled.
 * readOnly is being used as it allows for field focus, which is required to scroll user to validation error
 */
export const TextField = styled(Field)<{ readOnly?: boolean }>`
  ${({ theme, readOnly = false }) =>
    readOnly &&
    `
    > input {
        background-color: ${theme.colors.GREY_LIGHTER};
        cursor: not-allowed;
        color: ${theme.colors.GREY_DARK};
     }
  
  `};
`;
